import React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import uuidv4 from 'uuid';
import PropTypes from 'prop-types';

//material ui:
import { withStyles } from '@material-ui/core/styles';
import { Typography } from '@material-ui/core';
import CircularProgress from '@material-ui/core/CircularProgress';

import NeuriteGrid from '../../components/neurite_grid';

//actions:
import { openDialog, hideDialog, setSaveState } from '../../actions';
import { addLicenciaDeMaquina, removeLicenciaDeMaquina, modifyLicenciaDeMaquina } from '../../actions/maquina_licencias_actions';


const styles = theme => ({
    title: {
        margin: '5px 10px',
    },
    spinnerContainer: {
        width: '95%',
        height: 300,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
    },
    spinner: {
        width: '50px !important',
        height: '50px !important',
    },
});

class MaquinaLicencias extends React.Component {


    addLicencia = licencia => {
        this.props.setSaveState(true);
        this.props.addLicenciaDeMaquina(licencia);
    };

    modifyLicenciaMaquina = licencia => {
        this.props.setSaveState(true);
        this.props.modifyLicenciaDeMaquina(licencia);
    };

    messageDialog = msg => {

        this.props.openDialog('SimpleMessage', {
            message: msg
        }, uuidv4(), false, 'sm');

    };

    checkLicencia = licencia => {
        if (!licencia.licencia.trim()) {
            this.messageDialog('Por favor, rellene el campo Licencia');
            return false;
        } else if (licencia.fechaInicio < '1900-01-01T00:00:00') {
            this.messageDialog('Fecha de inicio inválida');
            return false;
        } else if (licencia.fechaFin < '1900-01-01T00:00:00') {
            this.messageDialog('Fecha de fin inválida');
            return false;
        } else if (licencia.fechaInicio > licencia.fechaFin) {
            this.messageDialog('Fecha de fin debe ser anterior a la de inicio');
            return false;
        } else if (!licencia.fechaInicio) {
            this.messageDialog('Por favor, rellene el Fecha Inicio');
            return false;
        } else if (!licencia.fechaFin) {
            this.messageDialog('Por favor, rellene el campo Fecha Fin');
            return false;
        }

        else return true;
    };

    newLicencia = () => {

        this.props.openDialog('EditLicenciaMaquina', {
            licencia: {},
            maquinaId: this.props.id,
            okHandler: this.addLicencia,
            checkLicencia: this.checkLicencia,
        }, uuidv4());

    };

    editLicencia = licencia => {

        this.props.openDialog('EditLicenciaMaquina', {
            licencia,
            maquinaId: this.props.id,
            okHandler: this.modifyLicenciaMaquina,
            checkLicencia: this.checkLicencia,
        }, uuidv4());

    }

    removeLicencia = licencia => {
        this.props.setSaveState(true);
        this.props.removeLicenciaDeMaquina(licencia);
    };


    render() {

        const { classes } = this.props;

        return (
            <div >
                <Typography variant="h6" className={classes.title} color={'primary'}>Licencias</Typography>

                {this.props.maquinalicencias && !this.props.isLoading ?
                    <NeuriteGrid
                    id="m_l"
                        columns={[
                            { key: 'licencia', name: 'Licencia', editable: false, dragable: false, width: 80 },
                            { key: 'fechaInicio', name: 'Fecha Inicio', editable: false, dragable: false, type: 'date', width: 80 },
                            { key: 'fechaFin', name: 'Fecha Fin', editable: false, dragable: false, type: 'date', width: 80 },

                        ]}
                        rows={this.props.maquinalicencias}
                        buttonEdit={true}
                        buttonDelete={true}
                        buttonNew={true}
                        onNewRowClick={this.newLicencia}
                        onEditClick={this.editLicencia}
                        onDeleteClick={this.removeLicencia}
                        height={200}
                    />
                    : <div className={classes.spinnerContainer}> <CircularProgress className={classes.spinner} color="primary" /> </div>}
            </div>
        );

    };

};

MaquinaLicencias.propTypes = {
    //state
    isLoading: PropTypes.bool.isRequired,
    maquinalicencias: PropTypes.array.isRequired,
    //dispatch
    openDialog: PropTypes.func.isRequired,
    hideDialog: PropTypes.func.isRequired,
    addLicenciaDeMaquina: PropTypes.func.isRequired,
    removeLicenciaDeMaquina: PropTypes.func.isRequired,
    modifyLicenciaDeMaquina: PropTypes.func.isRequired,
    //props:
    id: PropTypes.number.isRequired,
};

function mapStateToProps(state) {
    return {
        maquinalicencias: state.maquinalicencias.maquinalicencias,
        isLoading: state.maquinalicencias.isLoading,
    };
};

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        openDialog,
        hideDialog,
        addLicenciaDeMaquina,
        removeLicenciaDeMaquina,
        modifyLicenciaDeMaquina,
        setSaveState
    }, dispatch);
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(withStyles(styles, { withTheme: true })(MaquinaLicencias));